import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'

export default defineStore('groupStore', {
	state: () => {
		return {
			groups: [],
			// 新增：跟踪群聊中的参与者
			// key: groupId, value: Array<peer对象>
			groupAcceptedUsers: new Map()
		}
	},
	actions: {
		setGroups(groups) {
			this.groups = groups;
		},
		addGroup(group) {
			if (this.groups.some(g => g.id == group.id)) {
				this.updateGroup(group)
			} else {
				this.groups.unshift(group);
			}
		},
		removeGroup(id) {
			this.groups.filter(g => g.id == id).forEach(g => g.quit = true);
		},
		updateGroup(group) {
			this.groups.forEach((g, idx) => {
				if (g.id == group.id) {
					// 拷贝属性
					Object.assign(this.groups[idx], group);
				}
			})
		},
		updateTopMessage(id, topMessage) {
			let group = this.findGroup(id);
			if (group) {
				group.topMessage = topMessage;
			}
		},
		clear() {
			this.groups = [];
		},
		loadGroup() {
			return new Promise((resolve, reject) => {
				http({
					url: '/group/list',
					method: 'GET'
				}).then(groups => {
					this.setGroups(groups);
					resolve();
				}).catch(e => {
					reject(e);
				})
			});
		},
		
		// 新增：添加peer对象到群聊参与者列表
		addAcceptedUser(groupId, peer) {
			if (!this.groupAcceptedUsers.has(groupId)) {
				this.groupAcceptedUsers.set(groupId, []);
			}
			// 检查是否已存在该peer
			const existingPeer = this.groupAcceptedUsers.get(groupId).find(p => p.id === peer.id);
			if (!existingPeer) {
				this.groupAcceptedUsers.get(groupId).push(peer);
			}
		},
		
		// 新增：移除peer对象从群聊参与者列表
		removeAcceptedUser(groupId, peerId) {
			if (this.groupAcceptedUsers.has(groupId)) {
				const peers = this.groupAcceptedUsers.get(groupId);
				const index = peers.findIndex(p => p.id === peerId);
				if (index !== -1) {
					peers.splice(index, 1);
				}
				// 如果数组为空，删除整个entry
				if (peers.length === 0) {
					this.groupAcceptedUsers.delete(groupId);
				}
			}
		},
		
		// 新增：检查peer是否已在群聊参与者列表中
		isUserAccepted(groupId, peerId) {
			if (!this.groupAcceptedUsers.has(groupId)) {
				return false;
			}
			return this.groupAcceptedUsers.get(groupId).some(p => p.id === peerId);
		},
		
		// 新增：获取群聊中的peer对象列表
		getAcceptedUsers(groupId) {
			if (!this.groupAcceptedUsers.has(groupId)) {
				return [];
			}
			return this.groupAcceptedUsers.get(groupId);
		},
		
		// 新增：获取群聊中的参与者数量
		getAcceptedUserCount(groupId) {
			if (!this.groupAcceptedUsers.has(groupId)) {
				return 0;
			}
			return this.groupAcceptedUsers.get(groupId).length;
		},
		
		// 新增：清空群聊的参与者列表
		clearAcceptedUsers(groupId) {
			this.groupAcceptedUsers.delete(groupId);
		},
		
		// 新增：清空所有群聊的参与者列表
		clearAllAcceptedUsers() {
			this.groupAcceptedUsers.clear();
		}
	},
	getters: {
		findGroup: (state) => (id) => {
			return state.groups.find(g => g.id == id);
		},
		isGroup: (state) => (id) => {
			return state.groups.filter(g => !g.quit).some(g => g.id == id);
		},
	}
});